import { render } from "./IconChevronLast.vue?vue&type=template&id=7e49035f"
import script from "./IconChevronLast.vue?vue&type=script&lang=js"
export * from "./IconChevronLast.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__